module.exports = __webpack_public_path__ + "static/08-6e8dc4f55c52cf00457742f3e16ac82e.jpg";